import React, { useState } from "react";

import { useMutation } from "@apollo/client";
import { REMOVE_ACCOUNT } from "./gql";

import Sentry from "../../../api/sentry";
import {
  AGGREGATOR_TYPE_FINICITY,
  AGGREGATOR_TYPE_PLAID,
  DDA_ACCOUNTS,
  FETCH_ACCOUNTS_ERROR_MESSAGE,
  IS_MOBILE,
  REMOVE_ACCOUNTS_ERROR_MESSAGE,
} from "../../../constants";

// Components
import Loading from "../../common/Loading";
import { BankTile } from "../../linkbank/components";
import { GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";
import withQuery from "../wrappers/gql/withQuery";

const LinkBankAccounts = ({
  data: linkBankInfo,
  refetchQuery: fetchAccounts,
  setErrorNetwork = () => {},
  fromMockDashboard,
}) => {
  const { accountsByLogin } = linkBankInfo.getBankAccounts;
  const [removeAccountById, { loading: removeAccountLoading }] = useMutation(REMOVE_ACCOUNT);
  const [fetchAccountsloading, setFetchAccountsloading] = useState(false);

  // Helper Functions
  const removeAccount = async (userAccountId) => {
    try {
      await removeAccountById({
        variables: {
          id: userAccountId,
        },
      });
    } catch (err) {
      Sentry.captureException(err);
      setErrorNetwork(REMOVE_ACCOUNTS_ERROR_MESSAGE);
      return;
    }

    setFetchAccountsloading(true);
    try {
      await fetchAccounts();
    } catch (err) {
      Sentry.captureException(err);
      setErrorNetwork(FETCH_ACCOUNTS_ERROR_MESSAGE);
    } finally {
      setFetchAccountsloading(false);
    }
  };

  const loadingState = fetchAccountsloading || removeAccountLoading;

  return (
    <>
      {loadingState ? <Loading showBackdrop /> : null}
      <Accounts
        accountsByLogin={accountsByLogin}
        removeAccount={removeAccount}
        dda
        fromMockDashboard={fromMockDashboard}
      />
      <Accounts
        accountsByLogin={accountsByLogin}
        removeAccount={removeAccount}
        fromMockDashboard={fromMockDashboard}
      />
    </>
  );
};

/* Utility Functions */
const addLogoDataToAccounts = (accountsByLogin) => {
  return (accountsByLogin).reduce((totalAccounts, bankLoginAccount) => {
    const { accounts, aggregator, institution } = bankLoginAccount;
    const logoUrl = aggregator === AGGREGATOR_TYPE_FINICITY && institution.logo;
    const logo = aggregator === AGGREGATOR_TYPE_PLAID && institution.logo;
    const bankAccountsWithLogo = accounts.map((bankAccount) => {
      return { ...bankAccount, logo, logoUrl };
    });
    return [...totalAccounts, ...bankAccountsWithLogo];
  }, []);
};

// Components
const DDAAccountHeader = () => (
  <div className="font-light text-lg pb-3">
    Bank accounts
  </div>
);

const GenericAccountHeader = () => (
  <div className="font-light text-lg pb-3">
    Other accounts
  </div>
);

const Accounts = ({ accountsByLogin, removeAccount, dda, fromMockDashboard }) => {
  const accountsWithLogoData = addLogoDataToAccounts(accountsByLogin || []);
  const accounts = accountsWithLogoData.filter((account) =>
    (dda ? DDA_ACCOUNTS.includes(account.type) : !DDA_ACCOUNTS.includes(account.type)),
  );

  const AccountHeader = dda ? <DDAAccountHeader /> : <GenericAccountHeader />;

  return (
    <>
      {accounts.length > 0 ? AccountHeader : null}
      <div className="mb-4">
        {
          accounts.map((account) => {
            const { userAccountId, logo, logoUrl, name, mask } = account;
            return <BankTile
              key={userAccountId}
              logo={logo}
              logoUrl={logoUrl}
              name={name}
              accountNumber={mask}
              triggerOnHover={!IS_MOBILE}
              handleRemove={async () => {
                await removeAccount(userAccountId);
              }}
              dashboard={fromMockDashboard}
            />;
          })
        }
      </div>
    </>
  );
};

export default withQuery(GET_APP_INFO_AND_ACCOUNTS)(LinkBankAccounts);